import React, { useRef } from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HeroSlider from "./components/HeroSlider";
import About from "./components/About";
import Services from "./components/Services";
import Benefits from "./components/Benefits";
import Process from "./components/Process";
import ROICalculator from "./components/ROICalculator";
import Testimonials from "./components/Testimonials";
import EnquiryForm from "./components/EnquiryForm";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import SocialSignals from './components/SocialSignals';

function App() {
  const enquiryFormRef = useRef(null);

  const scrollToEnquiryForm = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <Header onGetQuoteClick={scrollToEnquiryForm} />
      <Hero onGetQuoteClick={scrollToEnquiryForm} />
      <HeroSlider />
      <SocialSignals />
      <About />
      <Services />
      <Benefits />
      <Process />
      <ROICalculator />
      <Testimonials />
      <CTASection onGetQuoteClick={scrollToEnquiryForm} />
      <EnquiryForm ref={enquiryFormRef} />
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
